const ITEMS = [
  "Treffi-illat",
  "Vanhempien oma aika",
  "Viikonloppuhoidot",
  "Yöhoito sovittaessa",
  "Sairaan lapsen hoito",
  "Tutustumiskäynti ensin",
];

const Row = ({ ariaHidden = false }) => (
  <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-petrol sm:text-3xl">
          {item}
        </span>
        <span className="text-beige-deep" aria-hidden="true">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="border-y border-line bg-greige/70 py-6 overflow-hidden" data-testid="editorial-marquee">
    <div className="marquee-track">
      <Row />
      <Row ariaHidden />
    </div>
  </div>
);
